import CheckBox from 'client/components/common/CheckBox/CheckBox'
import { SelectInput } from 'client/components/common/SelectInput/SelectInput'
import { ImportTypes } from 'client/components/Screen/ImportScreen/ImportScreen'
import { getFieldsForMapping } from 'client/components/Screen/ImportScreen/MappingView/MappingHeader/MappingHeaderHelper'
import { Mapping } from 'client/components/Screen/ImportScreen/MappingView/MappingView'
import _ from 'lodash'
import React from 'react'

interface MappingHeaderProps {
  type: ImportTypes
  fileContent: string[][]
  mapping: Mapping
  setMapping: React.Dispatch<React.SetStateAction<Mapping>>
  skip: number[]
  setSkip: React.Dispatch<React.SetStateAction<number[]>>
}

const MappingHeader: React.FC<MappingHeaderProps> = ({ type, fileContent, mapping, setMapping, skip, setSkip }) => {
  const selectFields = getFieldsForMapping(type)

  return (
    <>
      <div className="mapping-view__grid-checkbox">
        <CheckBox
          value={skip.length === 0}
          onChange={(value) => {
            if (value) {
              setSkip([])
            } else {
              setSkip(fileContent.map((row, i) => i))
            }
          }}
        />
      </div>
      {fileContent[0].map((row, i) => {
        const selectValue = _.findKey(mapping, (col) => col === i) || 'empty'
        return (
          <div key={`header-${i}`} className="mapping-view__grid-header">
            <SelectInput
              value={selectValue}
              map={selectFields}
              onChange={(value) => {
                let newMapping = { ...mapping }
                newMapping = _.pickBy(newMapping, (col) => col !== i)
                if (value !== 'empty') {
                  newMapping[value] = i
                }
                setMapping(newMapping)
              }}
            />
          </div>
        )
      })}
    </>
  )
}

export default MappingHeader
